/**
 * <hidden-read-more> — clamped text with a one-way "Read more" reveal.
 * Clicking the trigger removes the clamp and the trigger disappears
 * (gate decision 2026-07-28: no "Read less"). Markup contract:
 *   <hidden-read-more>
 *     <div data-clamp-target class="...">long text</div>
 *     <button data-read-more-trigger>Read more</button>
 *   </hidden-read-more>
 */
class HiddenReadMore extends HTMLElement {
  connectedCallback() {
    const trigger = this.querySelector('[data-read-more-trigger]');
    const target = this.querySelector('[data-clamp-target]');
    if (!(trigger instanceof HTMLElement) || !(target instanceof HTMLElement)) return;

    // If the text fits without clamping, the trigger is noise — remove it.
    if (target.scrollHeight <= target.clientHeight + 1) {
      trigger.remove();
      return;
    }

    trigger.addEventListener(
      'click',
      () => {
        target.classList.remove('is-clamped');
        trigger.remove();
      },
      { once: true }
    );
  }
}

if (!customElements.get('hidden-read-more')) {
  customElements.define('hidden-read-more', HiddenReadMore);
}
